import {createSlice} from "@reduxjs/toolkit";

const initialAppFlyerTokenState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  exportData: [], 
  appFlyerTokenlist: [],
  usersCount: null,
  allgameslist: null, 
  editAppFlyer: [],
  deletedAppFlyer: []
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const AppFlyerTokenSlice = createSlice({
  
  name: "gst",
  initialState: initialAppFlyerTokenState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    clearfetchStaffUsers: (state, action) => {
      state.listLoading = false;
      state.error = null;
      state.entities = [];
      state.totalCount = 0;
    },
    emptyList: (state, action) => {
      state.error = null;
      state.entities = [];
      // state.totalCount = 0;
      state.exportData = [];
    },
    // getstaffUserById
    appFlyerTokenList: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    AppFlyerTokenExport: (state, action) => {
      const { exportData } = action.payload;
      // state.listLoading = false;
      // state.error = null;
      state.exportData = exportData;
    },
    GamesList: (state, action) => {
      const { allgameslist } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.totalCount = 0;
      state.allgameslist = allgameslist;
    },
    updateAppFlyer: (state, action) => {
      const { editAppFlyer } = action.payload;
      state.error = null;
      state.editAppFlyer = editAppFlyer;
    },
    deleteAppFlyer: (state, action) => {
      const { deletedAppFlyer } = action.payload;
      state.error = null;
      state.deletedAppFlyer = deletedAppFlyer;
    },
  }
});
